/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDButton from "components/MDButton";
import CustomAlert from "components/CustomAlert";

// Data
import { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMaterialUIController, setLoading } from "context";
import { Alert, CircularProgress } from "@mui/material";
import CtrTable from "./tables/CtrTable";
import ImportList from "./ImportList";
import IrlTable from "./tables/IrlTable";
import OeeTable from "./tables/OeeTable";
import ConsumptionHistoryTable from "./tables/ConsumptionHistoryTable";
import ConsumptionHistoryFinishedProductTable from "./tables/ConsumptionHistoryFinishedProductTable";
import MaterialMasterTable from "./tables/MaterialMasterTable";
import FinishedProductMasterTable from "./tables/FinishedProductMasterTable";
import EpMasterTable from "./tables/EpMasterTable";
import OcMasterTable from "./tables/OcMasterTable";
import BalanceMasterTable from "./tables/BalanceMasterTable";
import OrderMasterTable from "./tables/OrderMasterTable";
import OrderMasterWithoutEPTable from "./tables/OrderMasterWithoutEPTable";
import UnitValueTable from "./tables/UnitValueTable";
import { useForm, Controller } from "react-hook-form";
import { KanbanAPI } from "api/KanbanAPI";
import { IrlAPI } from "api/IrlAPI";
import permissions from "permissions";
import MaterialMasterExclusiveTable from "./tables/MaterialMasterExclusiveTable";
import VnptuhTable from "./tables/VnptuhTable";

import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from "@mui/material/Autocomplete";
import TextField from '@mui/material/TextField';

import LinearProgress from "@mui/material/LinearProgress";

import { ProductionLineAPI } from "api/ProductionLineAPI";

export default function ProductArrays() {
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const [controller, dispatch] = useMaterialUIController();
  const [ctr, setCTR] = useState([]);
  const [irl, setIrl] = useState([]);
  // const [value, setValue] = useState(0);
  const { user, loading, admin } = controller;
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const message = location.state;

  const [menu, setMenu] = useState(null);
  const { handleSubmit, control, setValue, formState: { isSubmitting } } = useForm();

  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAlert = (content, color) => {
    setAlertContent(content);
    setAlertColor(color);
    setAlert(true)
  }

  const handleAlertClose = () => {
    setAlert(false);
  }

  const handleClick = (path) => {
    navigate(path);
  }

  // const [view, setView] = useState("ctr");
  const [view, setView] = useState(null);

  const [open, setOpen] = useState(null);

  const toggle = (key) => {
    setOpen(open === key ? null : key);
  };

  // const [ctrActions, setCtrActions] = useState({});
  const [openCtrModal, setOpenCtrModal] = useState(false);

  const handleOpenCtr = () => setOpenCtrModal(true);
  const handleCloseCtr = () => setOpenCtrModal(false);

  const [checkList, setCheckList] = useState({});

  const modules = [
    { key: "ctr", name: "CTR", import: false, last: checkList?.ctr?.importDate || null },
    { key: "irl", name: "IRL", import: false, last: checkList?.irl?.importDate || null },
    { key: "oee", name: "OEE", import: false, last: checkList?.oee?.importDate || null },
    { key: "consumo", name: "Historial de Consumo", import: true, last: checkList?.historico_consumo?.importDate || null, route: "consumption-history-import" },
    { key: "consumo_pt", name: "Historial de Consumo PT", import: true, last: checkList?.historico_consumo_producto_terminado?.importDate || null, route: "consumption-history-finished-product-import" },
    { key: "materiales", name: "Maestro Materiales", import: true, last: checkList?.maestro_materiales?.importDate || null, route: "material-master-import" },
    { key: "pt", name: "Maestro PT", import: true, last: checkList?.maestro_pt?.importDate || null, route: "finished-product-master-import" },
    { key: "ep", name: "Maestro Estructura de Producto", import: true, last: checkList?.maestro_ep?.importDate || null, route: "ep-master-import" },
    { key: "oc", name: "Maestro Órdenes de Compra", import: true, last: checkList?.maestro_oc?.importDate || null, route: "oc-master-import" },
    { key: "saldos", name: "Maestro Saldos", import: true, last: checkList?.maestro_saldos?.importDate || null, route: "balance-master-import" },
    { key: "pedidos", name: "Maestro Pedidos", import: true, last: checkList?.maestro_pedidos?.importDate || null, route: "order-master-import" },
    { key: "exclusivos", name: "Materiales exclusivos", import: true, last: checkList?.maestro_materiales_exclusivos?.importDate || null, route: "material-master-exclusive-import" },
    { key: "vn", name: "Valores Nominales", import: true, last: checkList?.valores_nominales?.importDate || null, route: "vn-pt-uh-import" },
    { key: "pt_sin_ep", name: "Productos sin Estructura", import: false, route: "pt-without-ep-import", last: checkList?.pt_sin_ep?.importDate || null }
  ];

  const [progress, setProgress] = useState(0);
  const [checkingProgress, setCheckingProgress] = useState(false);

  const startProgressWatcher = () => {
    setCheckingProgress(true);

    const interval = setInterval(() => {
      KanbanAPI.getCtrProgress()
        .then(res => {
          setProgress(res.percent);

          if (res.percent >= 100) {
            setCheckingProgress(false);
            clearInterval(interval);
          }
        })
        .catch(() => {
          clearInterval(interval);
          setCheckingProgress(false);
        });
    }, 30000);
  };

  const [reloadCtr, setReloadCtr] = useState(false);

  const calculateCtr = (data) => {
    // const selectedIds = data.linea;

    setLoading(dispatch, true);
    startProgressWatcher();

    return KanbanAPI.calculateCtr({
      selectedIds: data.linea,
      todas: data.todas
    })
      .then(response => {
        handleAlert(response.ctr.meta.message, response.status);

        handleCloseCtr();

        // refrescar tabla
        setReloadCtr(prev => !prev);
        getCheckList();
      })
      .catch(error => {
        if (error.response) {
          const { status, data } = error.response;

          if (status === 423) {
            handleAlert(
              data.message || "CTR en ejecución. Intenta más tarde.",
              "warning"
            );
            return;
          }

          handleAlert(
            data.message || "Error ejecutando CTR",
            data.status || "error"
          );
          handleCloseCtr();
        } else {
          handleAlert("Error desconocido al ejecutar CTR", "error");
          handleCloseCtr();
        }
      })
      .finally(() => {
        setLoading(dispatch, false);
        setCheckingProgress(false);
        handleCloseCtr();
      });
  };

  const [lineas, setLineas] = useState([]);
  const [selectedLineas, setSelectedLineas] = useState([]);

  const getProductionLine = () => {
    return ProductionLineAPI.index(true)
      .then(response => {

        const excludedLines = [
          "PROTOTIPO",
          "MULTILINEA"
        ];

        const productionLines = response.productionLines.filter(
          linea => !excludedLines.includes(
            linea.nombre_linea?.trim().toUpperCase()
          )
        );

        setLineas(productionLines);

        // if (response.productionLines.length > 0) {
        //   setSelectedLineas(response.productionLines);

        //   setValue("linea", response.productionLines.map(l => l.linea));
        // }
      })
      .catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error');
        }
      })
      .finally(() => {
        setLoading(dispatch, false);
      });
  };

  const [ptSinEpActions, setPtSinEpActions] = useState({});

  const [orderMaster, setOrderMaster] = useState([]);
  const [productType, setProductType] = useState("ALL");

  const getOrderMaster = () => {
    setLoading(dispatch, true);

    return KanbanAPI.order()
      .then(response => {
        setOrderMaster(response.data);
      })
      .catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error');
        }
      })
      .finally(() => {
        setLoading(dispatch, false);
      });
  };

  // const renderMenu = (
  //   <Menu
  //     id="simple-menu"
  //     anchorEl={menu}
  //     open={Boolean(menu)}
  //     onClose={closeMenu}
  //   >
  //     {(user?.permissions?.includes(permissions.product_arrays[6]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('consumption-history-import')}>Historial de Consumo</MenuItem>
  //     )}
  //     {(user?.permissions?.includes(permissions.product_arrays[7]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('material-master-import')}>Maestro de Materiales</MenuItem>
  //     )}
  //     {(user?.permissions?.includes(permissions.product_arrays[8]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('finished-product-master-import')}>Maestro Producto Terminado</MenuItem>
  //     )}
  //     {(user?.permissions?.includes(permissions.product_arrays[9]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('ep-master-import')}>Maestro EP</MenuItem>
  //     )}
  //     {(user?.permissions?.includes(permissions.product_arrays[10]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('oc-master-import')}>Maestro OC</MenuItem>
  //     )}
  //     {(user?.permissions?.includes(permissions.product_arrays[11]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('balance-master-import')}>Maestro Saldos</MenuItem>
  //     )}
  //     {(user?.permissions?.includes(permissions.product_arrays[12]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('order-master-import')}>Maestro Pedidos</MenuItem>
  //     )}
  //     {/* {(user?.permissions?.includes(permissions.product_arrays[13]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('unit-value-import')}>Valor Unitario</MenuItem>
  //     )} */}
  //     {(user?.permissions?.includes(permissions.product_arrays[14]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('consumption-history-finished-product-import')}>Historial de Consumo Producto Terminado</MenuItem>
  //     )}
  //     {(user?.permissions?.includes(permissions.product_arrays[15]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('op-master-import')}>Maestro OP</MenuItem>
  //     )}
  //     {(user?.permissions?.includes(permissions.product_arrays[16]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('vn-pt-uh-import')}>VN PT UH</MenuItem>
  //     )}
  //     {(user?.permissions?.includes(permissions.product_arrays[17]) || user?.role === admin) && (
  //       <MenuItem onClick={() => handleClick('material-master-exclusive-import')}>Maestro de Materiales Exclusivos</MenuItem>
  //     )}
  //   </Menu>
  // );

  useEffect(() => {
    if (message) {
      handleAlert(message, 'success');
    }
  }, [message]);

  useEffect(() => {
    window.history.replaceState({}, document.title);

    const abortController = new AbortController();
    const signal = abortController.signal;

    setLoading(dispatch, true);

    getProductionLine();

    return () => {
      abortController.abort();
    };
  }, []);

  const getCheckList = () => {
    return KanbanAPI.checkDataForCtr()
      .then(response => {
        setCheckList(response.data);
      })
      .catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error');
        }
      });
  };

  useEffect(() => {
    setLoading(dispatch, true);

    getCheckList();

  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={6}>
        <Dialog open={openCtrModal} onClose={handleCloseCtr} >
                <MDBox component="form" role="form" onSubmit={handleSubmit(calculateCtr)}>
                  <DialogTitle>Ejecución del CTR por todas las líneas</DialogTitle>
                  <DialogContent>
                    <Controller
                      name="linea"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Autocomplete
                          multiple
                          value={selectedLineas}
                          options={lineas}
                          getOptionLabel={(linea) => linea.nombre_linea}

                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label="Líneas"
                              placeholder="Líneas"
                            />
                          )}
                          onChange={(event, items) => {
                            setSelectedLineas(items);
                            const todasSeleccionadas = items.length === lineas.length;

                            setValue("todas", todasSeleccionadas);

                            onChange(items.map(item => item.linea)); // Mapear a los IDs seleccionados
                          }}
                        />
                      )}
                    />
                  </DialogContent>
                  <DialogActions>
                    <MDButton onClick={handleCloseCtr}>Cancelar</MDButton>
                    <MDButton type="submit" disabled={isSubmitting}>
                      {isSubmitting ? <CircularProgress size={18} color="info" /> : 'Calcular CTR'}
                    </MDButton>
                  </DialogActions>
                </MDBox>
              </Dialog>
        {/* <Grid container spacing={6}>
          <Grid item xs={12} lg={12}>
            <MDBox mb={4} px={2}>
              <CustomAlert severity={alertColor} message={alertContent} open={alert} onClose={handleAlertClose}></CustomAlert>
            </MDBox>
            <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', pb: 3 }}>
              {(user?.permissions.some(r => permissions.product_arrays.slice(6).includes(r)) || user?.role === admin) && (
                <MDButton endIcon={<KeyboardArrowDownIcon />} variant="gradient" color="info" onClick={openMenu}>Importar</MDButton>
              )}
            </MDBox>
            <MDBox mb={3}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" >
                <Tab label="CTR" />
                <Tab label="PT sin EP" />
                <Tab label="IRL" />
                <Tab label="OEE" />
                <Tab label="Historial de Consumo" />
                <Tab label="Historial de Consumo PT" />
                <Tab label="Maestro Materiales" />
                <Tab label="Maestro PT" />
                <Tab label="Maestro EP" />
                <Tab label="Maestro OC" />
                <Tab label="Maestro Saldos" />
                <Tab label="Maestro Pedidos" />
                <Tab label="Materiales exclusivos" />
                {/* <Tab label="Valor Unitario" /> */}
                {/* <Tab label="Maestro OP" />*/}
                {/* <Tab label="VN" /> 
              </Tabs>
            </MDBox>
            {renderMenu}
            <MDBox pb={3} px={1}>
              <ImportList handleAlert={handleAlert}></ImportList>
            </MDBox>
            <CustomTabPanel value={value} index={0} >
              <Card>
                <CtrTable handleAlert={handleAlert}></CtrTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Card>
                <OrderMasterWithoutEPTable handleAlert={handleAlert}></OrderMasterWithoutEPTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <Card>
                <IrlTable handleAlert={handleAlert}></IrlTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <Card>
                <OeeTable handleAlert={handleAlert}></OeeTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
              <Card>
                <ConsumptionHistoryTable handleAlert={handleAlert}></ConsumptionHistoryTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={5}>
              <Card>
                <ConsumptionHistoryFinishedProductTable handleAlert={handleAlert}></ConsumptionHistoryFinishedProductTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={6}>
              <Card>
                <MaterialMasterTable handleAlert={handleAlert}></MaterialMasterTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={7}>
              <Card>
                <FinishedProductMasterTable handleAlert={handleAlert}></FinishedProductMasterTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={8}>
              <Card>
                <EpMasterTable handleAlert={handleAlert}></EpMasterTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={9}>
              <Card>
                <OcMasterTable handleAlert={handleAlert}></OcMasterTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={10}>
              <Card>
                <BalanceMasterTable handleAlert={handleAlert}></BalanceMasterTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={11}>
              <Card>
                <OrderMasterTable handleAlert={handleAlert}></OrderMasterTable>
              </Card>
            </CustomTabPanel> */}
            {/* <CustomTabPanel value={value} index={11}>
              <Card>
                <UnitValueTable></UnitValueTable>
              </Card>
            </CustomTabPanel> */}
            {/* <CustomTabPanel value={value} index={12}>
              <Card>
                <MaterialMasterExclusiveTable handleAlert={handleAlert}></MaterialMasterExclusiveTable>
              </Card>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={13}>
              <Card>
                <VnptuhTable handleAlert={handleAlert}></VnptuhTable>
              </Card>
            </CustomTabPanel>
          </Grid>
        </Grid> */}
        {/* <Grid container spacing={3}>
              <Grid item xs={12} md={3}>
                <Card sx={{ p: 2 }}>
                  {sidebarMenu.map((section) => (
                    <div key={section.title}>
                      <MDBox fontWeight="bold" mb={1}>
                        {section.title}
                      </MDBox>

                      {section.items.map((item) => (
                        <MDBox
                          key={item.key}
                          onClick={() => setView(item.key)}
                          sx={{
                            p: 1,
                            mb: 0.5,
                            borderRadius: "8px",
                            cursor: "pointer",
                            backgroundColor:
                              view === item.key ? "rgba(0,0,0,0.1)" : "transparent",
                            "&:hover": {
                              backgroundColor: "rgba(0,0,0,0.05)",
                            },
                          }}
                        >
                          {item.label}
                        </MDBox>
                      ))}
                    </div>
                  ))}
                </Card>
              </Grid>

              <Grid item xs={12} md={9}>
                <Card>
                  {view === "ctr" && <CtrTable handleAlert={handleAlert} />}
                  {view === "irl" && <IrlTable handleAlert={handleAlert} />}
                  {view === "oee" && <OeeTable handleAlert={handleAlert} />}
                  
                  {view === "consumo" && <ConsumptionHistoryTable handleAlert={handleAlert} />}
                  {view === "consumo_pt" && <ConsumptionHistoryFinishedProductTable handleAlert={handleAlert} />}

                  {view === "materiales" && <MaterialMasterTable handleAlert={handleAlert} />}
                  {view === "pt" && <FinishedProductMasterTable handleAlert={handleAlert} />}
                  {view === "ep" && <EpMasterTable handleAlert={handleAlert} />}
                  {view === "oc" && <OcMasterTable handleAlert={handleAlert} />}
                  {view === "saldos" && <BalanceMasterTable handleAlert={handleAlert} />}
                  {view === "pedidos" && <OrderMasterTable handleAlert={handleAlert} />}

                  {view === "exclusivos" && <MaterialMasterExclusiveTable handleAlert={handleAlert} />}
                  {view === "vn" && <VnptuhTable handleAlert={handleAlert} />}
                </Card>
              </Grid>
          </Grid> */}

          {/* 🔹 1. TABLA DE MÓDULOS */}
      
        <Card sx={{ p: 2 }}>
          <MDBox mb={4} px={2}>
              <CustomAlert severity={alertColor} message={alertContent} open={alert} onClose={handleAlertClose}></CustomAlert>
            </MDBox>
          {modules.map((mod) => {
            const isOpen = open === mod.key;
            return (
            <MDBox key={mod.key} mb={1}>
              {/* 🔹 HEADER */}
              <MDBox
                onClick={() => toggle(mod.key)}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "200px 1fr 250px",
                  alignItems: "center",
                  p: 1.5,
                  borderRadius: "8px",
                  border: "1px solid #eee",
                  fontSize: "0.85rem",
                  transition: "all 0.2s",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#e4eaef" },
                }}
              >
              {/* Nombre + flecha */}
              <MDBox display="flex" alignItems="center" gap={1}>
                <IconButton
                  size="small"
                  sx={{
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "0.3s",
                  }}
                >
                  <KeyboardArrowDownIcon />
                </IconButton>

                <span>{mod.name}</span>
              </MDBox>

              {/* Fecha */}
              <MDBox textAlign="center" color="text.secondary">
                {mod.key === "ctr" && checkingProgress ? (
                  <MDBox>
                    <LinearProgress variant="determinate" value={progress} />
                    <span>{progress}%</span>
                  </MDBox>
                ) : (
                  <>
                    {mod.last ? (
                      <>
                        {mod.import ? "Última importación: " : "Última ejecución: "}
                        {mod.last}
                      </>
                    ) : (
                      <span style={{ color: "#999" }}>
                        {mod.import ? "Sin importación" : "Sin ejecución"}
                      </span>
                    )}
                  </>
                )}
              </MDBox>

              {/* Acciones */}
              <MDBox textAlign="right">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="info"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggle(mod.key);
                  }}
                  sx={{ mr: 1 }}
                >
                  Ver
                </MDButton>

                {mod.import && (
                  <MDButton
                    size="small"
                    variant="contained"
                    color="success"
                    disabled={!mod.route}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (mod.route) {
                        handleClick(mod.route);
                      }
                    }}
                  >
                    Importar
                  </MDButton>
                )}
                {mod.key === "ctr" && (
                  <MDButton
                    size="small"
                    variant="contained"
                    color="info"
                    disabled={checkingProgress}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenCtr();
                    }}
                    sx={{ ml: 1 }}
                  >
                    {checkingProgress ? `Calculando ${progress}%` : "Calcular"}
                  </MDButton>
                )}
                {mod.key === "pt_sin_ep" && (
                  <MDButton
                    size="small"
                    variant="contained"
                    color="info"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpen(mod.key); 
                      getOrderMaster();
                    }}
                    sx={{ ml: 1 }}
                  >
                    Consultar
                  </MDButton>
                )}
              </MDBox>
            </MDBox>

            {/* 🔹 CONTENIDO CON ANIMACIÓN */}
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
              <MDBox
                sx={{
                  p: 2,
                  border: "1px solid #eee",
                  borderTop: "none",
                  borderRadius: "0 0 8px 8px",
                  backgroundColor: "#fafafa",
                }}
              >
                {mod.key === "ctr" && (
                  <CtrTable reloadTrigger={reloadCtr} />
                )}
                {mod.key === "irl" && <IrlTable />}
                {mod.key === "oee" && <OeeTable />}
                {mod.key === "consumo" && <ConsumptionHistoryTable />}
                {mod.key === "consumo_pt" && <ConsumptionHistoryFinishedProductTable />}
                {mod.key === "materiales" && <MaterialMasterTable />}
                {mod.key === "pt" && <FinishedProductMasterTable />}
                {mod.key === "ep" && <EpMasterTable />}
                {mod.key === "oc" && <OcMasterTable />}
                {mod.key === "saldos" && <BalanceMasterTable />}
                {mod.key === "pedidos" && <OrderMasterTable />}
                {mod.key === "exclusivos" && <MaterialMasterExclusiveTable />}
                {mod.key === "vn" && <VnptuhTable />}
                {mod.key === "pt_sin_ep" && (
                  <OrderMasterWithoutEPTable
                    orderMaster={orderMaster}
                    productType={productType}
                    setProductType={setProductType}
                  />
                )}
              </MDBox>
            </Collapse>
          </MDBox>
          );
          })}

      </Card>

      {/* 🔹 2. CONTENIDO DINÁMICO (AQUÍ VA EL PUNTO 4) */}
      {/* <Card>
        {view === "ctr" && <CtrTable />}
        {view === "irl" && <IrlTable />}
        {view === "oee" && <OeeTable />}

        {view === "consumo" && <ConsumptionHistoryTable />}
        {view === "consumo_pt" && <ConsumptionHistoryFinishedProductTable />}

        {view === "materiales" && <MaterialMasterTable />}
        {view === "pt" && <FinishedProductMasterTable />}
        {view === "ep" && <EpMasterTable />}
        {view === "oc" && <OcMasterTable />}
        {view === "saldos" && <BalanceMasterTable />}
        {view === "pedidos" && <OrderMasterTable />}

        {view === "exclusivos" && <MaterialMasterExclusiveTable />}
        {view === "vn" && <VnptuhTable />}
      </Card> */}
      </MDBox>
      <Footer />
    </DashboardLayout >
  );
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <MDBox
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <MDBox sx={{ p: 1 }}>
        {children}
      </MDBox>

    </MDBox>
  );
}











